export enum RateTypeOptionsModel {
    CONTRACTED = "contracted",
    GROUP = "group",
    MANAGED = "managed"
}